/**
 * @fileoverview Shared mock adapter for the auth feature.
 * @description The one axios-mock-adapter instance for every identity endpoint, created once and
 * gated by VITE_ENABLE_MOCK_API. axios-mock-adapter installs itself by overwriting the axios
 * instance's defaults.adapter, so a second `new MockAdapter(httpClient)` elsewhere would silently
 * replace this one and drop its registered routes — every per-endpoint mock module
 * (auth-mock.service.ts, two-factor-mock.service.ts, password-reset-mock.service.ts,
 * session-mock.service.ts) registers its handlers on this single shared instance instead of
 * constructing its own. `onNoMatch: 'passthrough'` is what makes coexisting with the other
 * features' own mock adapters (notifications, sales) actually safe rather than merely
 * non-crashing: axios-mock-adapter captures whatever adapter function was active as
 * `originalAdapter` at construction time, and 'passthrough' falls through to it on a miss instead
 * of 404ing — so main.tsx's `import '@/features/auth'` before `import '@/features/notifications'`
 * before `import '@/features/sales'` forms a real chain (sales's misses fall through to
 * notifications, whose misses fall through to auth) rather than the last-constructed adapter
 * silently swallowing every other feature's requests.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import MockAdapter from 'axios-mock-adapter'

import { appConfig } from '@/config/app-config'
import { httpClient } from '@/shared/api/http-client'

export const authMockAdapter = appConfig.enableMockApi
  ? new MockAdapter(httpClient, { delayResponse: 700, onNoMatch: 'passthrough' })
  : null
